export default {
    list: {
        title: 'Mittenti',
        subtitle: 'Gestisci le tue collaborazioni con i spedizionieri',
        loading: 'Caricamento spedizionieri...',
        searchPlaceholder: 'Cerca per nome o email...',
        countryPlaceholder: 'Filtra per paese',
        allCountries: 'Tutti i paesi',
        tabs: {
            active: 'Mittenti Attivi',
            pending: 'Inviti Pending',
        },
        active: {
            title: 'Mittenti Attivi',
            description: 'Lista dei spedizionieri con cui collabori attivamente',
            headers: {
                company: 'Azienda',
                country: 'Paese',
                email: 'Email',
                status: 'Status',
                activeContainers: 'Container Attivi',
                totalContainers: 'Totale Container',
                lastContainer: 'Ultimo Container',
                collaborationDate: 'Data Collaborazione',
                actions: 'Azioni',
            },
        },
        receivedInvites: {
            title: 'Inviti Ricevuti',
            description: 'Inviti ricevuti da spedizionieri in attesa di accettazione',
            headers: {
                company: 'Azienda',
                country: 'Paese',
                email: 'Email',
                inviteDate: 'Data Invito',
                actions: 'Azioni',
            },
            accept: 'Accetta',
            reject: 'Rifiuta',
            confirmAccept: 'Sei sicuro di voler accettare questo invito?',
            confirmReject: 'Sei sicuro di voler rifiutare questo invito?',
        },
        sentInvites: {
            title: 'Inviti Inviati',
            description: 'Inviti inviati ai spedizionieri in attesa della loro accettazione',
            headers: {
                company: 'Azienda',
                country: 'Paese',
                email: 'Email',
                inviteDate: 'Data Invito',
                actions: 'Azioni',
            },
        },
        status: {
            active: 'Attivo',
            pending: 'In Attesa',
            rejected: 'Rifiutato',
            suspended: 'Sospeso',
        },
        confirmSuspend: 'Sei sicuro di voler sospendere questa collaborazione?',
        confirmDelete: 'Sei sicuro di voler eliminare questa collaborazione?',
        none: 'Nessuno',
    },
    detail: {
        loading: 'Caricamento dettagli spedizioniere...',
        notFound: {
            title: 'Mittente non trovato',
            message: 'Il spedizioniere richiesto non esiste o non hai i permessi per visualizzarlo.',
        },
        backToList: 'Torna alla lista',
        info: {
            title: 'Informazioni',
            collaboration: 'Collaborazione',
            companyInfo: 'Informazioni Anagrafiche',
            containerStats: 'Statistiche Container',
            fields: {
                legalName: 'Ragione Sociale',
                entityType: 'Tipo Entità',
                taxId: 'Tax ID',
                country: 'Paese',
                address: 'Indirizzo',
                email: 'Email',
                phone: 'Telefono',
            },
            stats: {
                total: 'Totale',
                inTransit: 'In Transito',
                delivered: 'Consegnati',
                delayed: 'Ritardati',
                pendingDocuments: 'Doc Pending',
                highRisk: 'Alto Rischio',
            },
        },
        containers: {
            title: 'Container da questo Mittente',
            count: 'di',
            searchPlaceholder: 'Cerca per container ID o route...',
            statusPlaceholder: 'Filtra per stato',
            riskPlaceholder: 'Filtra per rischio',
            documentsPlaceholder: 'Filtra per documenti',
            headers: {
                containerId: 'Container ID',
                route: 'Route',
                progress: 'Progress',
                status: 'Status',
                docStatus: 'Doc Status',
                riskLevel: 'Risk Level',
                value: 'Valore',
                actions: 'Azioni',
            },
            noContainers: {
                title: 'Nessun container trovato',
                message: 'Prova a modificare i filtri di ricerca',
                emptyMessage: 'Nessun container ricevuto da questo spedizioniere ancora',
            },
            viewDetails: 'Visualizza Dettagli',
        },
    },
};
